/** Premier passage : pas de société = pas de Clients / Paramètres. */
import { CompanyCreateForm } from "./CompanyCreateForm";

export function NeedCompany() {
  return (
    <section className="fx-need-co">
      <h2 className="fx-modal__title">Créer la société</h2>
      <CompanyCreateForm />
    </section>
  );
}
